class CustomQuantitySelector extends HTMLElement {
  constructor() {
    super()
    this.minusBtn = this.querySelector('.custom-quantity-selector__btn--minus')
    this.plusBtn = this.querySelector('.custom-quantity-selector__btn--plus')
    this.quantityInput = this.querySelector('.custom-quantity-selector__input')

    this.originalMinusBtn = this.closest('.product-info').querySelector('.qty-input__btn.btn--minus')
    this.originalPlusBtn = this.closest('.product-info').querySelector('.qty-input__btn.btn--plus')
    this.originalQuantityInput = this.closest('.product-info').querySelector('.qty-input__input')

    this.minusBtn.addEventListener('click', this.onMinusBtnClick.bind(this))
    this.plusBtn.addEventListener('click', this.onPlusBtnClick.bind(this))
    this.quantityInput.addEventListener('input', this.onQuantityInputChange.bind(this))
  }

  onMinusBtnClick() {
    this.originalMinusBtn.click()
    this.quantityInput.value = this.originalQuantityInput.value
  }

  onPlusBtnClick() {
    this.originalPlusBtn.click()
    this.quantityInput.value = this.originalQuantityInput.value
  }

  onQuantityInputChange() {
    this.originalQuantityInput.value = this.quantityInput.value
  }
}

customElements.define('custom-quantity-selector', CustomQuantitySelector)

class PackBox extends HTMLElement {
  constructor() {
    super()
    this.pricePerItemBefore = this.dataset.pricePerItemBefore
    this.pricePerItemAfter = this.dataset.pricePerItemAfter

    this.addEventListener('click', this.onClick)
  }

  onClick() {
    const pricePerItemBeforeEl = document.querySelector('.pack-price-per-item--before')
    const pricePerItemAfterEl = document.querySelector('.pack-price-per-item--after')

    if (pricePerItemBeforeEl) pricePerItemBeforeEl.innerHTML = this.pricePerItemBefore
    if (pricePerItemAfterEl) pricePerItemAfterEl.innerHTML = this.pricePerItemAfter
  }
}

customElements.define('pack-box', PackBox)
